import React from 'react'
import MainRouter from './MainRouter.js'
import {BrowserRouter} from 'react-router-dom'
import {ThemeProvider, createTheme} from '@mui/material/styles'
import {indigo, pink} from '@mui/material/colors'
import NavMenus from './NavMenus.js'
import './App.css';

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
    light: '#757de8',
    main: '#3f51b5',
    dark: '#002984',
    contrastText: '#fff',
  },
  secondary: {
    light: '#ff79b0',
    main: '#ff4081',
    dark: '#c60055',
    contrastText: '#000',
  },
    openTitle: indigo['400'],
    protectedTitle: pink['400'],
    type: 'light'
  }
})

function App() {
  return (
      <BrowserRouter>
        <ThemeProvider theme={theme}>        
          <NavMenus />
          <MainRouter/>
        </ThemeProvider>          
      </BrowserRouter>
  );
}

export default App;
